import Link from 'next/link';
import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import { getAssetUrl } from '@utils/common.utils';
interface InstagramButtonPropTypes {
  authorSocialLink?: string;
}
const InstagramButton = ({ authorSocialLink }: InstagramButtonPropTypes) => {
  return (
    <Link href={authorSocialLink ?? ''}>
      <a target="_blank" rel="noreferrer">
        <ImageComponent
          elementype="native"
          loading="lazy"
          width="36"
          height="36"
          src={getAssetUrl('common', '/social-media/instgram-circle.svg')}
        />
      </a>
    </Link>
  );
};

export default InstagramButton;
